/* Cravinbyandy — Catering "Cravin' Essentials" service popup.
   Card / arrow click opens the modal at that service; the rail switches panels;
   ESC / overlay / X close; gallery thumb swaps the main image. Focus-trapped. */
(function () {
  function initSection(section) {
    var modal = section.querySelector('.csm');
    if (!modal || modal.dataset.csInit) return;
    modal.dataset.csInit = '1';

    var cards = section.querySelectorAll('[data-cs-index]');
    var openers = section.querySelectorAll('[data-cs-open]');
    var navs = modal.querySelectorAll('[data-cs-nav]');
    var panels = modal.querySelectorAll('[data-cs-panel]');
    var closers = modal.querySelectorAll('[data-cs-close]');
    var dialog = modal.querySelector('.csm__dialog');
    var lastFocus = null;

    // Adaptive image column: the photo is shown uncropped (CSS caps its width + height), so
    // its rendered width varies with aspect ratio and viewport height. Set the column width
    // to that rendered width so the column HUGS the photo — thumb strip + text align to it,
    // no dead gap. Pure CSS can't (intrinsic sizing ignores max-height on a replaced element).
    function fitVisual(main) {
      if (!main) return;
      var visual = main.closest('.csm__visual');
      if (!visual || !main.naturalWidth || !main.naturalHeight) return; // not loaded
      // Compute the displayed width DETERMINISTICALLY from the CSS caps + the photo's natural
      // aspect, rather than measuring the rendered box (which is transiently off during layout
      // settle / scrollbar reflow). getComputedStyle resolves the min()/calc() caps to px.
      var cs = getComputedStyle(main);
      var maxW = parseFloat(cs.maxWidth);
      var maxH = parseFloat(cs.maxHeight);
      var aspect = main.naturalWidth / main.naturalHeight;
      var w;
      if (maxW > 0 && maxH > 0) {
        // Uniform scale-DOWN to fit both caps — but never upscale past the photo's own pixels
        // (a small gallery image renders at its natural width, so the column must too).
        w = Math.min(maxW, maxH * aspect, main.naturalWidth);
      } else {
        var h = main.getBoundingClientRect().height; // fallback: measured height × aspect
        if (h < 1) return;
        w = h * aspect;
      }
      var px = Math.round(w) + 'px';
      if (visual.style.width !== px) visual.style.width = px;
    }
    function fitActive() {
      var panel = modal.querySelector('.csm__panel:not([hidden])');
      if (panel) requestAnimationFrame(function () { fitVisual(panel.querySelector('[data-cs-main]')); });
    }

    function activate(i) {
      i = String(i);
      navs.forEach(function (n) {
        var on = n.getAttribute('data-cs-nav') === i;
        n.classList.toggle('is-active', on);
        n.setAttribute('aria-selected', on ? 'true' : 'false');
        n.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-cs-panel') !== i; });
      fitActive();
    }

    function open(i) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('csm-open');
      // activate AFTER unhiding — scrollIntoView is a no-op while the rail is display:none
      activate(i);
      var active = modal.querySelector('.csm__navitem.is-active');
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (dialog) dialog.focus();
    }

    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('csm-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open(parseInt(o.getAttribute('data-cs-open'), 10) || 0);
      });
    });
    cards.forEach(function (c) {
      c.addEventListener('click', function () { open(parseInt(c.getAttribute('data-cs-index'), 10) || 0); });
      // the card face is a button in all but name — keep it keyboard-operable
      c.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        open(parseInt(c.getAttribute('data-cs-index'), 10) || 0);
      });
    });
    navs.forEach(function (n) {
      n.addEventListener('click', function () { activate(parseInt(n.getAttribute('data-cs-nav'), 10) || 0); });
    });
    closers.forEach(function (c) { c.addEventListener('click', close); });

    // Keep every panel's column hugging its image. A ResizeObserver on each image is the
    // reliable trigger — it fires on load, on a thumb swap (new aspect), on the layout
    // settle, and on viewport resize (the height cap is vh-based, so a portrait's rendered
    // width changes with the window), always with the FINAL measured width.
    modal.querySelectorAll('[data-cs-main]').forEach(function (main) {
      if (window.ResizeObserver) {
        new ResizeObserver(function () { fitVisual(main); }).observe(main);
      } else {
        if (main.complete) fitVisual(main);
        main.addEventListener('load', function () { fitVisual(main); });
      }
    });
    var rT;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () { if (!modal.hidden) fitActive(); }, 120);
    });

    // one listener per section, scoped to the modal so it can be torn down with it
    modal.addEventListener('keydown', onKeydown);
    document.addEventListener('keydown', onKeydown);
    function onKeydown(e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab' && dialog) {
        var f = dialog.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    modal.querySelectorAll('[data-cs-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var panel = t.closest('[data-cs-panel]');
        if (!panel) return;
        var main = panel.querySelector('[data-cs-main]');
        var img = t.querySelector('img');
        if (!main || !img) return;
        panel.querySelectorAll('[data-cs-thumb]').forEach(function (o) {
          o.classList.toggle('is-active', o === t);
        });
        // compare resolved URLs — main and thumb are served at different widths
        var next = t.getAttribute('data-cs-full') || img.currentSrc || img.src;
        if (main.getAttribute('src') === next) return;
        main.style.opacity = '0';
        var done = false;
        var swap = function () {
          if (done) return;
          done = true;
          main.src = next;
          main.style.opacity = '';
          main.removeEventListener('transitionend', swap);
        };
        main.addEventListener('transitionend', swap);
        setTimeout(swap, 220); // guard for transitions-off / reduced-motion
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cservices]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
